import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function OfferSummarySection() {
  return <section className="py-24 bg-mint relative overflow-hidden" data-id="element-244">
      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-245">
        <FadeIn data-id="element-246">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-sage/20" data-id="element-247">
            <div className="bg-forest text-white p-10 md:p-12 text-center relative overflow-hidden" data-id="element-248">
              <div className="absolute inset-0 opacity-10" data-id="element-249">
                <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-sage" data-id="element-250"></div>
                <div className="absolute -bottom-10 -left-10 w-32 h-32 rounded-full bg-gold" data-id="element-251"></div>
              </div>
              <div className="relative z-10" data-id="element-252">
                <span className="inline-block py-1 px-4 rounded-full bg-white/15 text-white/90 font-semibold text-xs tracking-widest mb-4 uppercase" data-id="element-253">
                  Oferta exclusiva
                </span>
                <h2 className="text-3xl md:text-4xl font-bold leading-tight" data-id="element-254">
                  Resumen de tu oferta completa
                </h2>
                <p className="text-white/80 mt-3 text-lg font-light" data-id="element-255">
                  Todo lo que recibís hoy por solo{' '}
                  <span className="font-bold text-gold" data-id="element-256">$6,39 USD</span>
                </p>
              </div>
            </div>

            <div className="p-8 md:p-12" data-id="element-257">
              <div className="space-y-4 mb-10" data-id="element-258">
                {/* Table Rows */}
                <div className="flex justify-between items-center p-4 bg-cream rounded-xl" data-id="element-259">
                  <span className="font-medium text-gray-800" data-id="element-260">
                    Protocolo SOS 72H (producto principal)
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-261">
                    $27 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-white border border-gray-100 rounded-xl" data-id="element-262">
                  <span className="font-medium text-gray-700" data-id="element-263">
                    BONO #1 — Mapa Rápido SOS
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-264">
                    $17 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-cream rounded-xl" data-id="element-265">
                  <span className="font-medium text-gray-700" data-id="element-266">
                    BONO #2 — Checklist Restaurantes
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-267">
                    $17 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-white border border-gray-100 rounded-xl" data-id="element-268">
                  <span className="font-medium text-gray-700" data-id="element-269">
                    BONO #3 — Tracker 72H Claro
                  </span>
                  <span className="font-bold text-gray-500 line-through" data-id="element-270">
                    $13 USD
                  </span>
                </div>

                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl mt-6 border-t-2 border-gray-200" data-id="element-271">
                  <span className="font-bold text-gray-800" data-id="element-272">VALOR TOTAL</span>
                  <span className="font-bold text-gray-800" data-id="element-273">$74 USD</span>
                </div>

                <div className="flex justify-between items-center p-6 bg-sage/10 rounded-xl border-2 border-sage" data-id="element-274">
                  <span className="font-bold text-xl text-forest" data-id="element-275">
                    TU INVERSIÓN HOY
                  </span>
                  <span className="font-bold text-3xl text-forest" data-id="element-276">
                    $6,39 USD
                  </span>
                </div>
              </div>

              <div className="text-center max-w-2xl mx-auto" data-id="element-277">
                <h2 className="text-2xl md:text-3xl font-bold text-forest mb-6" data-id="element-278">
                  Todo esto por una fracción de lo que vale.
                </h2>

                <div className="text-gray-600 space-y-4 mb-10 leading-relaxed" data-id="element-279">
                  <p data-id="element-280">
                    Podés seguir intentando "comer bien a ojo" y despertarte
                    mañana con el mismo abdomen tenso y la misma neblina mental.
                  </p>
                  <p data-id="element-281">
                    O podés invertir menos de lo que gastás en un almuerzo de
                    oficina y tener un sistema completo que te dice exactamente
                    qué hacer, cómo medirlo y cómo mantenerlo.
                  </p>
                  <p data-id="element-282">
                    La inflamación no desaparece sola. Pero con el sistema
                    correcto, puede desaparecer en 72 horas.
                  </p>
                  <p className="text-sm font-semibold text-sage bg-sage/10 inline-block px-4 py-2 rounded-lg mt-4" data-id="element-283">
                    Los 3 bonos solo están disponibles en esta página y con esta
                    oferta. No se venden por separado.
                  </p>
                </div>

                <div className="flex flex-col items-center gap-4" data-id="element-284">
                  <Button className="w-full md:w-auto" data-id="element-285" />
                  <p className="text-sm text-gray-500" data-id="element-286">
                    Descarga instantánea en PDF. Acceso de por vida. Sin
                    suscripciones.
                  </p>
                  <button className="text-xs text-gray-400 hover:text-gray-600 underline underline-offset-4 mt-4 transition-colors" data-id="element-287">
                    No gracias, prefiero seguir sintiéndome inflamada y cansada
                    sin un plan claro.
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}